import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectAppSecretKeyData = (store: StoreSchema) => store.applicationSecretKey